// extracted by mini-css-extract-plugin
export default {"responsivestack":"About_responsivestack__3Lodb","stackcontainer":"About_stackcontainer__aVjam","responsivestackitem":"About_responsivestackitem__eBqFJ"};